export default __webpack_public_path__ + "static/voronej-cd36317e4f9b1d90e078b1a5f3b7d372.webp";